module.exports = __webpack_public_path__ + "img/MainBG.40dc9a38.png";